import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ListTypeHandicapComponent } from './list-typeHandicap/list-typeHandicap.component';
import { FilterTypeHandicapByNamePipe } from 'src/app/shared/pipes/filter-typeHandicap-by-name/filter-typeHandicap-by-name.pipe';
import { TypeHandicapModalDetailComponent } from './modal/typeHandicap-modal-detail/typeHandicap-modal-detail.component';
import { TypeHandicapModalAjoutComponent } from './modal/typeHandicap-modal-ajout/typeHandicap-modal-ajout.component';

@NgModule({
	declarations: [
		ListTypeHandicapComponent,
		TypeHandicapModalDetailComponent,
		TypeHandicapModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeHandicapByNamePipe]
})

export class TypeHandicapModule {}
